SP.lang.Class.define("SP.sitekit.form.validator.Number", {

	_options: null,
	_message: null,

	init: function (options) {
		this._options = options;
	},

	isValid: function (value) {

		if (isNaN(value)) {
			this._message = this._options.decimal === true ? this._options.messages.decimal : this._options.messages.integer;
			return false;
		} else if (value === null || value === "") {
			return true;
		}

		value = parseFloat(value.replace(",", "."));
		if (this._options.decimal === true) {
			if (!SP.isFloat(value) && !SP.isInt(value)) {
				this._message = this._options.messages.decimal;
				return false;
			}
		} else {
			if(!SP.isInt(value)) {
				this._message = this._options.messages.integer;
				return false;
			}
		}

		return true;
	},

	getMessage: function () {
		return this._message;
	}

});
